export default {
  dbh_url_collection_shortcuts_title: '我的收藏',
  dbh_url_collection_new_features_title: '新功能',
  dbh_url_collection_edit: '编辑',
  dbh_url_collection_more: '更多',
  dbh_url_collection_edit_modal_title: '编辑个人收藏',
  dbh_url_collection_add_shortcut: '添加收藏',
  dbh_url_collection_max_count_message: '已达到6条收藏的上限。请删除一个收藏以添加新的收藏。',
  dbh_url_collection_delete_confirm_title: '您确定要删除吗？',
  dbh_url_collection_rename: '重命名',
  dbh_url_collection_delete: '删除',
  dbh_url_collection_name_required: '名称不能为空。',
  dbh_url_collection_name_too_long: '名称不能超过 80 个字符。',
  dbh_url_collection_duplicate_name: '该名称已被使用。',
  dbh_url_collection_duplicate_url: '该页面已添加至收藏。',
  dbh_url_collection_url_required: '请输入 DataBrain 页面链接。',
  dbh_url_collection_analyse_failed: '链接识别失败，请稍后重试。',
  dbh_url_collection_invalid_system: '当前链接对应的系统不受支持。',
  dbh_url_collection_save_success: '保存成功！',
  dbh_url_collection_save_failed: '保存失败，请稍后重试。',
  dbh_url_collection_analyse_modal_title: '添加至收藏',
  dbh_url_collection_analyse_modal_url_label: 'URL',
  dbh_url_collection_analyse_modal_url_placeholder: '请输入 DataBrain 页面链接',
  dbh_url_collection_analyse_modal_import: '导入',
  dbh_url_collection_analyse_modal_auto_import: '自动导入',
  dbh_url_collection_analyse_modal_page_name_label: '名称',
  dbh_url_collection_analyse_modal_page_name_placeholder: 'URL识别后自动填入',
  dbh_url_collection_analyse_modal_identify_success: '识别成功！',
  dbh_url_collection_analyse_modal_preview_empty: '导入 DataBrain 链接后，在此处预览快捷方式信息。',
  dbh_url_collection_analyse_modal_no_permission: '无法添加此收藏，你没有访问该URL的权限。',
  dbh_url_collection_analyse_modal_unavailable: '该页面暂不可用，或对应实体已失效。',
  dbh_url_collection_analyse_modal_invalid: '不支持的链接。请填入支持的游戏页面URL',
  dbh_url_collection_analyse_modal_preview_link: '预览页面',
  dbh_url_collection_analyse_modal_path_label: '路径',
  dbh_url_collection_analyse_modal_url_value_label: '链接',
  dbh_url_collection_analyse_modal_system_benchmark: '行业基准',
  dbh_url_collection_analyse_modal_name_error: '自动识别URL填充失败',
  dbh_url_collection_analyse_modal_name_error_unsupported: '不支持的链接。请使用受支持的游戏页面 URL。',
  dbh_url_collection_analyse_modal_name_error_no_permission: '无法添加此收藏。你没有访问该 URL 的权限。',
  dbh_url_collection_shortcuts_empty: '收藏你最喜欢的页面，一键进入',
  dbh_url_collection_new_features_empty: '暂无新功能推荐，敬请期待',
};
